<template>
  <div class="bookStack-main">
    <div class="bookStack-main-header">
      <div class="bookStack-main-header-info">
        <img
          v-if="!bookInfo.image_url"
          src="@/assets/img/cmb_book_cover.png"
          alt=""
        />
        <img v-else :src="bookInfo.image_url" alt="" />
        <div class="bookStack-info">
          <div class="bookStack-title">
            <h4>
              {{ $t("content.books.stackName") }}：{{
                bookInfo ? bookInfo.name : $t("commonMsg.none")
              }}
            </h4>
          </div>
          <p class="bookStack-count">
            {{ $t("content.books.bookCount") }}：{{
              bookInfo ? bookInfo.booksTotal : 0
            }}
          </p>
          <p class="bookStack-count">
            {{ $t("content.books.onlineBook") }}：{{
              bookInfo ? bookInfo.booksTotal : 0
            }}
          </p>
        </div>
      </div>
      <div class="bookStack-btn" v-if="!selectCtrl">
        <div class="bookStack-btn-edit">
          <button
            v-if="sourceType !== 4"
            :disabled="!Object.keys(bookInfo).length"
            :class="{ disbaledBtn: !Object.keys(bookInfo).length }"
            class="global-button-style"
            @click.stop="editBookStack"
          >
            {{ $t("commonMsg.edit") }}
          </button>
        </div>
        <div>
          <button
            v-if="sourceType !== 4"
            :disabled="!Object.keys(bookInfo).length"
            :class="{ disbaledBtn: !Object.keys(bookInfo).length }"
            class="global-button-style"
            @click.stop="batchUpload"
          >
            {{ $t("content.books.batchUpload") }}
          </button>
          <button
            v-if="sourceType !== 4"
            :disabled="!Object.keys(bookInfo).length"
            :class="{ disbaledBtn: !Object.keys(bookInfo).length }"
            class="global-button-style"
            @click="addBooks"
          >
            {{ $t("content.books.addBook") }}
          </button>
          <button
            :disabled="!Object.keys(bookInfo).length"
            :class="{ disbaledBtn: !Object.keys(bookInfo).length }"
            class="global-button-style"
            @click.stop="manageBook"
          >
            {{ $t("commonMsg.manage") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sourceType: {
      type: Number,
      default: 0
    },
    bookInfo: {
      type: Object
    },
    selectCtrl: {
      type: Boolean
    }
  },
  data() {
    return {
      isSelect: false
    };
  },
  methods: {
    // 编辑书单信息
    editBookStack() {
      this.$emit("editBookStack");
    },
    //添加书籍
    addBooks() {
      if (!this.$route.query.id) {
        this.elMsg("请选择类目再进行书籍添加", "warning");
        return;
      }
      this.$router.push({ name: "addBooks", query: { ...this.$route.query } });
    },
    batchUpload() {
      this.$emit("batchUpload");
    },
    manageBook() {
      this.isSelect = true;
      this.$emit("manageBook", this.isSelect, "handle");
    }
  }
};
</script>

<style lang="scss" scoped>
.bookStack-main {
  .bookStack-main-header {
    display: flex;
    padding: 10px 20px 20px;
    border-bottom: 1px solid $globalBorderColor;
    justify-content: space-between;
    .bookStack-main-header-info {
      display: flex;
      > img {
        width: 100px;
        height: 120px;
      }
      > .bookStack-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 30px;
        .bookStack-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          > i {
            width: 26px;
            height: 28px;
            display: inline-block;
            background: url("~@//assets/img/cmb_edit.png") center no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bookStack-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bookStack-btn-edit {
      text-align: right;
    }
    .disbaledBtn {
      background: #ccc;
      cursor: not-allowed;
    }
  }
}
</style>
